import { render } from "./project_job.vue?vue&type=template&id=b849e0c0&scoped=true"
import script from "./project_job.vue?vue&type=script&lang=js"
export * from "./project_job.vue?vue&type=script&lang=js"

import "./project_job.vue?vue&type=style&index=0&id=b849e0c0&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b849e0c0"]])

export default __exports__